/**
 * state.ts — active account/business ที่หน้าจอ CRUD ใช้ (ตั้งค่าตอน bootstrap live)
 */
export interface ActiveTenant {
  accountId: string;
  businessId: string;
  accountName: string;
  businessName: string;
}

let _tenant: ActiveTenant | null = null;

export function setTenant(t: ActiveTenant | null): void {
  _tenant = t;
}
export function getTenant(): ActiveTenant | null {
  return _tenant;
}

/**
 * โหมด UI: 'simple' = เวอร์ชันเรียบง่ายสำหรับแม่ค้าทั่วไป (ค่าเริ่มต้น),
 *          'advanced' = โหมดบัญชีเต็ม (โมดูลครบ)
 * เก็บใน localStorage ต่อเบราว์เซอร์ (ภายหลังผูกกับแพ็กเกจ/บัญชีได้)
 */
export type UiMode = 'simple' | 'advanced';
const UI_MODE_KEY = 'rrp_ui_mode';

export function getUiMode(): UiMode {
  try {
    return localStorage.getItem(UI_MODE_KEY) === 'advanced' ? 'advanced' : 'simple';
  } catch {
    return 'simple';
  }
}
export function setUiMode(mode: UiMode): void {
  try {
    localStorage.setItem(UI_MODE_KEY, mode);
  } catch {
    /* ignore */
  }
}
